import React from 'react'
import { AppDialog, AppDialogBody, AppDialogHeader } from '@components'
import { reportSearchesModalId } from '@signals'
import AppReportSearchesModalContent from './Content'
import { REPORT_STATUS } from '@constants'


export default function AppReportSearchesModal({ data, isExtras = false, progressText }) {
	if (reportSearchesModalId.value === null || data.length <= 0) return null

	const {
		name,
		statusLastExecution,
		status_last_execution,
		status,
	} = data?.filter(a => a?.idLastExecution === reportSearchesModalId.value || a?.id_last_execution === reportSearchesModalId.value || a?.id_batch === reportSearchesModalId.value)[0]
	const isRunning = statusLastExecution === REPORT_STATUS.RUNNING || status_last_execution === REPORT_STATUS.RUNNING || status === REPORT_STATUS.RUNNING
	const onClose = () => reportSearchesModalId.value = null

	return <AppDialog
		open={reportSearchesModalId.value !== null}
		onClose={onClose}
		maxWidth="lg"
	>
		<AppDialogHeader
			icon="gauge-high"
			title={name}
			subtitle={progressText ? `Search summary · ${progressText}` : 'Search summary'}
			onClose={onClose}
		/>
		<AppDialogBody>
			<AppReportSearchesModalContent
				id_report={reportSearchesModalId.value}
				isRunning={isRunning}
				isExtras={isExtras}
			/>
		</AppDialogBody>
	</AppDialog>
}
